export default __webpack_public_path__ + "static/easy-ecd85f6ed4144770d52eac2d79dab285.svg";